var cov_2odz98ch7l = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/index.ts",
      hash = "3dcb505ef3bf65f69697fdcbb700a53a6006b4ff",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/utils/validate/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 24,
          column: 3
        }
      },
      "1": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 23,
          column: 21
        }
      },
      "2": {
        start: {
          line: 22,
          column: 53
        },
        end: {
          line: 22,
          column: 89
        }
      },
      "3": {
        start: {
          line: 23,
          column: 9
        },
        end: {
          line: 23,
          column: 21
        }
      },
      "4": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 25,
          column: 56
        }
      },
      "5": {
        start: {
          line: 25,
          column: 33
        },
        end: {
          line: 25,
          column: 56
        }
      },
      "6": {
        start: {
          line: 26,
          column: 65
        },
        end: {
          line: 26,
          column: 70
        }
      },
      "7": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 28,
          column: 41
        }
      },
      "8": {
        start: {
          line: 30,
          column: 2
        },
        end: {
          line: 30,
          column: 106
        }
      },
      "9": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 34,
          column: 44
        }
      },
      "10": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 34,
          column: 44
        }
      },
      "11": {
        start: {
          line: 34,
          column: 6
        },
        end: {
          line: 34,
          column: 44
        }
      },
      "12": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 107
        }
      },
      "13": {
        start: {
          line: 36,
          column: 36
        },
        end: {
          line: 36,
          column: 107
        }
      },
      "14": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 90
        }
      },
      "15": {
        start: {
          line: 38,
          column: 14
        },
        end: {
          line: 38,
          column: 90
        }
      },
      "16": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "17": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 43,
          column: 5
        }
      },
      "18": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 78
        }
      },
      "19": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 82
        }
      },
      "20": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 47,
          column: 46
        }
      },
      "21": {
        start: {
          line: 47,
          column: 12
        },
        end: {
          line: 47,
          column: 46
        }
      },
      "22": {
        start: {
          line: 49,
          column: 14
        },
        end: {
          line: 49,
          column: 70
        }
      },
      "23": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 50,
          column: 20
        }
      },
      "24": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 11
        }
      },
      "25": {
        start: {
          line: 54,
          column: 18
        },
        end: {
          line: 92,
          column: 4
        }
      },
      "26": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 92,
          column: 4
        }
      },
      "27": {
        start: {
          line: 61,
          column: 19
        },
        end: {
          line: 61,
          column: 65
        }
      },
      "28": {
        start: {
          line: 62,
          column: 17
        },
        end: {
          line: 62,
          column: 31
        }
      },
      "29": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 66,
          column: 5
        }
      },
      "30": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 19
        }
      },
      "31": {
        start: {
          line: 65,
          column: 6
        },
        end: {
          line: 65,
          column: 12
        }
      },
      "32": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 70,
          column: 5
        }
      },
      "33": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 68
        }
      },
      "34": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 12
        }
      },
      "35": {
        start: {
          line: 72,
          column: 21
        },
        end: {
          line: 79,
          column: 5
        }
      },
      "36": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 76,
          column: 7
        }
      },
      "37": {
        start: {
          line: 74,
          column: 8
        },
        end: {
          line: 74,
          column: 37
        }
      },
      "38": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 14
        }
      },
      "39": {
        start: {
          line: 78,
          column: 6
        },
        end: {
          line: 78,
          column: 68
        }
      },
      "40": {
        start: {
          line: 81,
          column: 15
        },
        end: {
          line: 81,
          column: 35
        }
      },
      "41": {
        start: {
          line: 82,
          column: 14
        },
        end: {
          line: 82,
          column: 19
        }
      },
      "42": {
        start: {
          line: 83,
          column: 4
        },
        end: {
          line: 85,
          column: 5
        }
      },
      "43": {
        start: {
          line: 84,
          column: 6
        },
        end: {
          line: 84,
          column: 28
        }
      },
      "44": {
        start: {
          line: 86,
          column: 15
        },
        end: {
          line: 86,
          column: 71
        }
      },
      "45": {
        start: {
          line: 87,
          column: 4
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "46": {
        start: {
          line: 88,
          column: 6
        },
        end: {
          line: 90,
          column: 8
        }
      },
      "47": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 89,
          column: 32
        }
      }
    },
    fnMap: {
      "0": {
        name: "getRule",
        decl: {
          start: {
            line: 20,
            column: 9
          },
          end: {
            line: 20,
            column: 16
          }
        },
        loc: {
          start: {
            line: 20,
            column: 83
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 20
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 33,
            column: 11
          },
          end: {
            line: 33,
            column: 12
          }
        },
        loc: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 44
          }
        },
        line: 34
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 54,
            column: 18
          },
          end: {
            line: 54,
            column: 19
          }
        },
        loc: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 92,
            column: 4
          }
        },
        line: 60
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 60,
            column: 14
          },
          end: {
            line: 60,
            column: 15
          }
        },
        loc: {
          start: {
            line: 60,
            column: 35
          },
          end: {
            line: 92,
            column: 3
          }
        },
        line: 60
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 72,
            column: 21
          },
          end: {
            line: 72,
            column: 22
          }
        },
        loc: {
          start: {
            line: 72,
            column: 60
          },
          end: {
            line: 79,
            column: 5
          }
        },
        line: 72
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 88,
            column: 47
          },
          end: {
            line: 88,
            column: 48
          }
        },
        loc: {
          start: {
            line: 88,
            column: 61
          },
          end: {
            line: 90,
            column: 7
          }
        },
        line: 88
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 20,
            column: 60
          },
          end: {
            line: 20,
            column: 81
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 20,
            column: 79
          },
          end: {
            line: 20,
            column: 81
          }
        }],
        line: 20
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        }, {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 24,
            column: 3
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 23,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 23,
            column: 21
          }
        }, {
          start: {
            line: 22,
            column: 4
          },
          end: {
            line: 23,
            column: 21
          }
        }],
        line: 22
      },
      "3": {
        loc: {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 56
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 56
          }
        }, {
          start: {
            line: 25,
            column: 2
          },
          end: {
            line: 25,
            column: 56
          }
        }],
        line: 25
      },
      "4": {
        loc: {
          start: {
            line: 26,
            column: 10
          },
          end: {
            line: 26,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 26,
            column: 17
          },
          end: {
            line: 26,
            column: 27
          }
        }],
        line: 26
      },
      "5": {
        loc: {
          start: {
            line: 30,
            column: 18
          },
          end: {
            line: 30,
            column: 106
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 30,
            column: 50
          },
          end: {
            line: 30,
            column: 64
          }
        }, {
          start: {
            line: 30,
            column: 68
          },
          end: {
            line: 30,
            column: 105
          }
        }],
        line: 30
      },
      "6": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 34,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 34,
            column: 44
          }
        }, {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 34,
            column: 44
          }
        }],
        line: 32
      },
      "7": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 107
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 107
          }
        }, {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 107
          }
        }],
        line: 36
      },
      "8": {
        loc: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 90
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 90
          }
        }, {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 90
          }
        }],
        line: 38
      },
      "9": {
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }, {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        }],
        line: 40
      },
      "10": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 40,
            column: 29
          }
        }, {
          start: {
            line: 40,
            column: 33
          },
          end: {
            line: 40,
            column: 56
          }
        }],
        line: 40
      },
      "11": {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 43,
            column: 5
          }
        }],
        line: 41
      },
      "12": {
        loc: {
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 41,
            column: 8
          },
          end: {
            line: 41,
            column: 25
          }
        }, {
          start: {
            line: 41,
            column: 29
          },
          end: {
            line: 41,
            column: 47
          }
        }],
        line: 41
      },
      "13": {
        loc: {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 46
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 46
          }
        }, {
          start: {
            line: 47,
            column: 2
          },
          end: {
            line: 47,
            column: 46
          }
        }],
        line: 47
      },
      "14": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 66,
            column: 5
          }
        }],
        line: 63
      },
      "15": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }, {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 70,
            column: 5
          }
        }],
        line: 67
      },
      "16": {
        loc: {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 76,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 76,
            column: 7
          }
        }, {
          start: {
            line: 73,
            column: 6
          },
          end: {
            line: 76,
            column: 7
          }
        }],
        line: 73
      },
      "17": {
        loc: {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }, {
          start: {
            line: 83,
            column: 4
          },
          end: {
            line: 85,
            column: 5
          }
        }],
        line: 83
      },
      "18": {
        loc: {
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 83,
            column: 8
          },
          end: {
            line: 83,
            column: 19
          }
        }, {
          start: {
            line: 83,
            column: 24
          },
          end: {
            line: 83,
            column: 51
          }
        }, {
          start: {
            line: 83,
            column: 55
          },
          end: {
            line: 83,
            column: 82
          }
        }],
        line: 83
      },
      "19": {
        loc: {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }, {
          start: {
            line: 87,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }],
        line: 87
      },
      "20": {
        loc: {
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 21
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 8
          },
          end: {
            line: 87,
            column: 10
          }
        }, {
          start: {
            line: 87,
            column: 14
          },
          end: {
            line: 87,
            column: 21
          }
        }],
        line: 87
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0, 0],
      "19": [0, 0],
      "20": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import Datum from '../../Datum';
import { wrapFormError } from '../errors';
import { substitute } from '../strings';
import { flattenArray } from '../flat';
import range from './range';
import rangeLength from './rangeLength';
import required from './required';
import typeOf from './type';
import regTest from './regExp';

function getRule(rules) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_2odz98ch7l.b[0][0]++, {});
  cov_2odz98ch7l.f[0]++;
  cov_2odz98ch7l.s[0]++;

  if (typeof rules === 'function') {
    cov_2odz98ch7l.b[1][0]++;
    cov_2odz98ch7l.s[1]++;

    if (rules.isInnerValidator) {
      cov_2odz98ch7l.b[2][0]++;
      cov_2odz98ch7l.s[2]++;
      rules = rules();
    } else {
      cov_2odz98ch7l.b[2][1]++;
      cov_2odz98ch7l.s[3]++;
      return rules;
    }
  } else {
    cov_2odz98ch7l.b[1][1]++;
  }

  cov_2odz98ch7l.s[4]++;

  if (typeof props === 'string') {
    cov_2odz98ch7l.b[3][0]++;
    cov_2odz98ch7l.s[5]++;
    props = {
      type: props
    };
  } else {
    cov_2odz98ch7l.b[3][1]++;
  }

  var _ref = (cov_2odz98ch7l.s[6]++, rules),
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? (cov_2odz98ch7l.b[4][0]++, props.type) : _ref$type,
      message = _ref.message,
      regExp = _ref.regExp,
      func = _ref.func,
      other = _objectWithoutProperties(_ref, ["type", "message", "regExp", "func"]);

  cov_2odz98ch7l.s[7]++;
  props = Object.assign({}, props, other);
  cov_2odz98ch7l.s[8]++;
  props.message = typeof message === 'function' ? (cov_2odz98ch7l.b[5][0]++, message(props)) : (cov_2odz98ch7l.b[5][1]++, substitute(message, props));
  cov_2odz98ch7l.s[9]++;

  if (func) {
    cov_2odz98ch7l.b[6][0]++;
    cov_2odz98ch7l.s[10]++;
    return function (value, formData, callback) {
      cov_2odz98ch7l.f[1]++;
      cov_2odz98ch7l.s[11]++;
      return func(value, formData, callback, props);
    };
  } else {
    cov_2odz98ch7l.b[6][1]++;
  }

  cov_2odz98ch7l.s[12]++;

  if (other.required !== undefined) {
    cov_2odz98ch7l.b[7][0]++;
    cov_2odz98ch7l.s[13]++;
    return required({
      message: props.message,
      required: !!props.required
    });
  } else {
    cov_2odz98ch7l.b[7][1]++;
  }

  cov_2odz98ch7l.s[14]++;

  if (regExp) {
    cov_2odz98ch7l.b[8][0]++;
    cov_2odz98ch7l.s[15]++;
    return regTest(regExp, {
      message: props.message
    });
  } else {
    cov_2odz98ch7l.b[8][1]++;
  }

  cov_2odz98ch7l.s[16]++;

  if ((cov_2odz98ch7l.b[10][0]++, other.min !== undefined) || (cov_2odz98ch7l.b[10][1]++, other.max !== undefined)) {
    cov_2odz98ch7l.b[9][0]++;
    cov_2odz98ch7l.s[17]++;

    if ((cov_2odz98ch7l.b[12][0]++, type === 'number') || (cov_2odz98ch7l.b[12][1]++, type === 'integer')) {
      cov_2odz98ch7l.b[11][0]++;
      cov_2odz98ch7l.s[18]++;
      return range({
        message: props.message,
        min: other.min,
        max: other.max
      });
    } else {
      cov_2odz98ch7l.b[11][1]++;
    }

    cov_2odz98ch7l.s[19]++;
    return rangeLength({
      message: props.message,
      min: other.min,
      max: other.max
    });
  } else {
    cov_2odz98ch7l.b[9][1]++;
  }

  cov_2odz98ch7l.s[20]++;

  if (type) {
    cov_2odz98ch7l.b[13][0]++;
    cov_2odz98ch7l.s[21]++;
    return typeOf(type, props.message);
  } else {
    cov_2odz98ch7l.b[13][1]++;
  }

  var err = (cov_2odz98ch7l.s[22]++, new Error("Rule ".concat(JSON.stringify(rules), " is not valid.")));
  cov_2odz98ch7l.s[23]++;
  console.error(err);
  cov_2odz98ch7l.s[24]++;
  throw err;
}

cov_2odz98ch7l.s[25]++;

var validate = function validate(value, formdata, rules, props) {
  cov_2odz98ch7l.f[2]++;
  cov_2odz98ch7l.s[26]++;
  return new Promise(function (resolve, reject) {
    cov_2odz98ch7l.f[3]++;
    var $rules = (cov_2odz98ch7l.s[27]++, flattenArray(rules));
    var rule = (cov_2odz98ch7l.s[28]++, $rules.shift());
    cov_2odz98ch7l.s[29]++;

    if (rule === undefined) {
      cov_2odz98ch7l.b[14][0]++;
      cov_2odz98ch7l.s[30]++;
      resolve(true);
      cov_2odz98ch7l.s[31]++;
      return;
    } else {
      cov_2odz98ch7l.b[14][1]++;
    }

    cov_2odz98ch7l.s[32]++;

    if (!rule) {
      cov_2odz98ch7l.b[15][0]++;
      cov_2odz98ch7l.s[33]++;
      validate(value, formdata, $rules, props).then(resolve, reject);
      cov_2odz98ch7l.s[34]++;
      return;
    } else {
      cov_2odz98ch7l.b[15][1]++;
    }

    cov_2odz98ch7l.s[35]++;

    var callback = function callback(result) {
      cov_2odz98ch7l.f[4]++;
      cov_2odz98ch7l.s[36]++;

      if (result !== true) {
        cov_2odz98ch7l.b[16][0]++;
        cov_2odz98ch7l.s[37]++;
        reject(wrapFormError(result));
        cov_2odz98ch7l.s[38]++;
        return;
      } else {
        cov_2odz98ch7l.b[16][1]++;
      }

      cov_2odz98ch7l.s[39]++;
      validate(value, formdata, $rules, props).then(resolve, reject);
    };

    var fn = (cov_2odz98ch7l.s[40]++, getRule(rule, props));
    var val = (cov_2odz98ch7l.s[41]++, value);
    cov_2odz98ch7l.s[42]++;

    if ((cov_2odz98ch7l.b[18][0]++, fn === rule) && ((cov_2odz98ch7l.b[18][1]++, value instanceof Datum.List) || (cov_2odz98ch7l.b[18][2]++, value instanceof Datum.Form))) {
      cov_2odz98ch7l.b[17][0]++;
      cov_2odz98ch7l.s[43]++;
      val = value.getValue();
    } else {
      cov_2odz98ch7l.b[17][1]++;
    }

    var cb = (cov_2odz98ch7l.s[44]++, fn(val, formdata, callback));
    cov_2odz98ch7l.s[45]++;

    if ((cov_2odz98ch7l.b[20][0]++, cb) && (cov_2odz98ch7l.b[20][1]++, cb.then)) {
      cov_2odz98ch7l.b[19][0]++;
      cov_2odz98ch7l.s[46]++;
      cb.then(callback.bind(null, true))["catch"](function (e) {
        cov_2odz98ch7l.f[5]++;
        cov_2odz98ch7l.s[47]++;
        reject(wrapFormError(e));
      });
    } else {
      cov_2odz98ch7l.b[19][1]++;
    }
  });
};

export default validate;